const isNumber = (value: any): value is number => Number(value) === value;

export default isNumber;
